module.exports = __webpack_public_path__ + "img/avatar0.a4ed36f1.png";